import React, { useEffect, useState } from 'react';
import InputField from '../../../../../component/form/FormInput';
import InputSelect from '../../../../../component/inputSelect/InputSelect';
import ImageUpload from '../../../../../component/uplaodImage';
import { useDispatch, useSelector } from 'react-redux';
import { formatErrors, hasPermission } from '../../../../../utils/controller';
import { product_code_get, product_create } from '../../../../../store/action/product';
import { product_group_list } from '../../../../../store/action/group';
import { product_catogery_list } from '../../../../../store/action/catogery';
import Checkbox from '../../../../../component/checkbox';
import { getTaxRates } from '../../../../../services/settings/organization';
import { toast } from 'react-toastify';
import Modal from '../../../../../component/modal/Modal';
import AddProductGroup from '../../../../inventory/product/productGroup/AddProductGroup';
import CreateGroupCodeModel from '../../../../inventory/product/productGroup/createGroupCodeModel';
import ProductCatogery from '../../../../inventory/product/productCatogery/ProductCatogery';
import Addshelf from '../../../../inventory/product/shelf/Shelf';
import { shelf_list } from '../../../../../store/action/shelf';
import AddPackagingModel from '../../../../components/addPackagingModel';
import {
	getMeasuringUnitGeneral,
	getPackagingGeneral,
} from '../../../../../services/settings/inventory';
import { ObjectCreate } from '../../../../../utils/utility';
import AddMeasuringUnitModel from '../../../../components/addMeasuringUnitModel';
import Button from '../../../../../component/ui/Button';
import { master_data } from '../../../../../store/action/master';
import { HSN_list } from '../../../../../store/action/utility';

export default function AddProductModel({
	isOpenProductModal,
	setIsOpenProductModal,
	getProductList,
	invoiceTable,
	tableIndex,
	setInvoiceTable,
}) {
	const user = useSelector((state) => state?.userInfo?.userInfo?.data);
	const HSNData = useSelector((state) => state?.utility?.data?.data);
	const dispatch = useDispatch();
	const [open, setOpen] = useState(false);
	const [isSheifId, setIsShelfId] = useState(false);
	const [isOpenCatogery, setIsOpenCatogery] = useState(false);
	const [isPackagingFocus, setPackagingFocus] = useState(false);
	const [isOpenGroupCodeModel, setIsOpenGroupCodeModel] = useState(false);
	const [isOpenPackagingModel, setIsOpenPackagingModel] = useState(false);
	const [isMeasuringUnitFocus, setMeasuringUnitFocus] = useState(false);
	const [isOpenMeasuringUnitModel, setIsOpenMeasuringUnitModel] = useState(false);
	const [loader, setLoader] = useState(false);
	const [persistGroupName, setPersistGroupName] = useState('');
	const [persistCategory, setPersistCategory] = useState('');
	const [productCode, setProductCode] = useState('');
	const [group, setGroup] = useState('');
	const [groupCode, setGroupCode] = useState('');
	const [category, setCategory] = useState('');
	const [shelf, setShelf] = useState('');
	const [persistShlef, setPersistShelf] = useState('');

	const [groupOption, setGroupOptions] = useState([]);
	const [catogeryOption, setCatogeryOption] = useState([]);
	const [packagingOption, setPackagingOption] = useState([]);
	const [unitOption, setUnitOption] = useState([]);
	const [HSNoption, setHSNoption] = useState([]);
	const [shelfOption, setShelfOption] = useState([]);
	const [taxesList, setTaxesList] = useState([]);
	const params = { page: 1, pageSize: 2000, filterBy: 'status', filterValue: '1' };
	const [error, setError] = useState({});
	const [autoFocus, setAutoFocus] = useState({
		catogrey: false,
		product: false,
		shelf: false,
		tax1: false,
	});
	const [formData, setFormData] = useState({
		name: '',
		hsn_id: '',
		packaging_id: '',
		contains: '',
		unit_id: '',
		sell_loose: true,
		tax1: null,
		tax2: null,
		purchase_discount: '',
		min_stock: '',
		max_stock: '',
		generic_name: '',
		product_image: null,
	});

	const HandleGroupChange = async (value, code) => {
		setGroup(value);
		setGroupCode(code);
		if (value) {
			delete error?.product_group_id;
		}
		if (code) {
			getProductCode(value);
		}
	};
	const handleCatogery = (value) => {
		setCategory(value);
		if (value) {
			delete error?.category_id;
		}
	};

	const handleImageUpload = (imageFile) => {
		const updatedData = { ...formData, product_image: imageFile };
		setFormData(updatedData);
	};

	const handleCheckboxChange = (checked) => {
		const updatedData = { ...formData, sell_loose: checked };
		setFormData(updatedData);
	};

	const handleInputChange = (key, value, required = false) => {
		const updatedData = { ...formData, [key]: value };
		setFormData(updatedData);
		if (required) {
			if (value) {
				delete error?.[key];
			} else {
			}
		}
	};

	const checkValidation = () => { };

	const SubmitForm = () => {
		const isErrorShow = checkValidation();
		if (isErrorShow) {
			toast.error('Unable to create or update product');
		} else {
			const dataToSubmit = new FormData();
			for (const key in formData) {
				dataToSubmit.append(key, formData[key]);
			}
			dataToSubmit.append('product_code', productCode?.toString());
			dataToSubmit.append('product_group_id', group?.toString());
			dataToSubmit.append('category_id', category?.toString());
			dataToSubmit.append('shelf_id', shelf?.toString());
			dataToSubmit.append('product_batch', JSON.stringify([]));
			setLoader(true);
			dispatch(product_create(dataToSubmit)).then((res) => {
				if (res?.success) {
					const { product } = res.data;
					toast.success(res?.message);
					let table = [...invoiceTable];
					table[tableIndex].product_id = product.product_id;
					table[tableIndex].product_tax1 = product?.tax1 ?? 0;
					table[tableIndex].product_tax2 = product?.tax2 ?? 0;
					setInvoiceTable(table);
					getProductList(params);
					setLoader(false);
					setIsOpenProductModal(false);
				} else {
					setLoader(false);
					let errorObj = formatErrors(res?.data?.message);
					setError(errorObj);
					toast.error(res?.response?.data?.message);
				}
			});
		}
	};

	async function getProductCode(value) {
		let param = `product_group_id=${value}`;
		var res = await product_code_get(param);
		if (res?.success) {
			setProductCode(res?.data);
			delete error?.product_code;
		}
	}
	const shelfList = async () => {
		let param = `page=${1}&pageSize=1000`;
		var res = await shelf_list(param);
		if (res?.success) {
			var shelves = res?.data?.shelves;
			const shelvesData = shelves?.map((shelve) => {
				return {
					key: shelve?.shelf_id,
					value: shelve?.name,
				};
			});

			setShelfOption(shelvesData);
			setPersistShelf('');
		}
	};
	// Fetch active product groups as an object param to populate group dropdown
	const groupList = async () => {
		let param = {
			page: 1,
			pageSize: 1000,
			filterBy: 'status',
			filterValue: 1,
			isDropdown: true,
		};
		var res = await product_group_list(param);
		if (res?.success) {
			var productData = res?.data?.productGroups;
			const productGroups = productData?.map((product) => {
				return {
					key: product?.product_group_id,
					value: product?.name,
				};
			});

			setGroupOptions(productGroups || []);
			setPersistGroupName('');
		}
	};
	const catogeryList = async () => {
		let param = `page=${1}&pageSize=1000`;
		var res = await product_catogery_list(param);
		if (res?.success) {
			var categoryData = res?.data?.productCategories;
			const categories = categoryData?.map((category) => {
				return {
					key: category?.category_id,
					value: category?.name,
				};
			});
			setCatogeryOption(categories);
			setPersistCategory('');
		}
	};
	const getTaxesList = async () => {
		try {
			const { tax_rates } = await getTaxRates({
				pageSize: 10000,
				page: 1,
				filterBy: 'is_active',
				filterValue: true,
			});
			const taxes = tax_rates.map((data) => {
				return {
					key: Number(data.tax_rate_id),
					value: `${data.tax_name} ${data.rate_in_percentage}%`,
				};
			});
			setTaxesList(taxes);
		} catch (error) {
			toast.error(error.message || 'Somenthing went wrong!');
		}
	};
	const getInventoryPackaging = async () => {
		try {
			const { packages } = await getPackagingGeneral({
				filterBy: 'is_active',
				filterValue: true,
				pageSize: 10000,
				page: 1,
			});
			const data = ObjectCreate({
				data: packages,
				key: 'id',
				value: 'name',
			});
			setPackagingOption(data);
		} catch (error) {
			toast.error(error.message || 'Something went wrong!');
		}
	};
	const getInventoryMeasuringUnit = async () => {
		try {
			const { units } = await getMeasuringUnitGeneral({
				filterBy: 'is_active',
				filterValue: true,
				pageSize: 10000,
				page: 1,
			});

			const data = units?.map((item) => {
				return {
					key: item.id,
					value: item.name,
					short_name: item.short_name,
				};
			});
			// const data = ObjectCreate({
			// 	data: units,
			// 	key: 'id',
			// 	value: 'name',
			// });
			setUnitOption(data);
		} catch (error) {
			toast.error(error.message || 'Something went wrong!');
		}
	};
	useEffect(() => {
		const result = ObjectCreate({
			data: HSNData,
			key: 'hsn_id',
			value: 'hsn_code',
		});
		setHSNoption(result);
	}, [HSNData]);

	useEffect(() => {
		getInventoryPackaging();
		getInventoryMeasuringUnit();
		getTaxesList();
		dispatch(master_data());
		dispatch(HSN_list());
	}, []);

	useEffect(() => {
		groupList();
	}, [persistGroupName]);

	useEffect(() => {
		catogeryList();
	}, [persistCategory]);

	useEffect(() => {
		shelfList();
	}, [persistShlef]);

	return (
		<>
			<Modal
				className="product_model"
				title={'Add New Product'}
				isOpen={isOpenProductModal}
				onClose={() => {
					setIsOpenProductModal(false);
				}}
				cancelButton={() => {
					setIsOpenProductModal(false);
				}}
			>
				<div style={{ padding: '1rem 1rem 3rem 1rem' }}>
					<div className="row">
						<div className="col-5 mt-4">
							<InputSelect
								options={groupOption || []}
								placeholder="Select Group"
								label="Select Group"
								onChange={(value) => {
									HandleGroupChange(value, '');
									getProductCode(value);
								}}
								value={group}
								onAddNew={
									hasPermission('inventory.groups.create', user?.role?.role_permissions)
										? () => setOpen(true)
										: ''
								}
								required={true}
								error={error?.product_group_id}
								autoFocus={false}
							/>
						</div>
						<div className="col-5 mt-4">
							<InputSelect
								label="Select Category"
								placeholder="Select Category"
								onChange={(value) => handleCatogery(value)}
								value={category}
								options={catogeryOption || []}
								onAddNew={() => setIsOpenCatogery(true)}
								required={true}
								error={error?.category_id}
								autoFocus={false}
							/>
						</div>
						<div className="col">
							<ImageUpload
								imageUrl={formData.product_image}
								onImageUpload={handleImageUpload}
								error={error?.image}
							/>
						</div>
					</div>
					<div className="row">
						<div className="col">
							<InputField
								label="Product Name"
								placeholder="Product Name"
								type="text"
								required={true}
								value={formData.name}
								onChange={(valueData) => {
									const value = valueData.replace(/[^A-Za-z0-9\s'/-]/g, '');
									handleInputChange('name', value);
								}}
								error={error?.name}
								autoFocus={false}
							/>
						</div>
						<div className="col">
							<InputField
								label="Product Code"
								placeholder="Product Code"
								type="text"
								required={true}
								value={productCode}
								error={error?.product_code}
							/>
						</div>
						<div className="col">
							<InputSelect
								options={HSNoption || []}
								placeholder="Select HSN Code"
								label="HSN code"
								onChange={(value) => handleInputChange('hsn_id', value)}
								value={formData.hsn_id}
								infoIcon
								required={true}
								error={error?.hsn_id}
							/>
						</div>
					</div>
					<div className="row">
						<div className="col-8">
							<div className="row justify-content-start align-items-start">
								<div className="col-4">
									<InputSelect
										label="Packing"
										placeholder="Packing"
										onChange={(value) => handleInputChange('packaging_id', value)}
										value={formData.packaging_id}
										options={packagingOption || []}
										infoIcon={true}
										required={true}
										autoFocus={isPackagingFocus}
										error={error?.packaging_id}
										onAddNew={() => {
											setIsOpenPackagingModel(true);
											setPackagingFocus(false);
										}}
									/>
								</div>
								<div className="col-2">
									<InputField
										label="Contains"
										placeholder="0"
										type="number"
										onChange={(value) => handleInputChange('contains', value)}
										value={formData.contains}
										error={error?.contains}
										required={true}
									/>
								</div>
								<div className="col-3">
									<InputSelect
										label="Unit"
										placeholder="Select Unit"
										onChange={(value) => handleInputChange('unit_id', value)}
										value={formData.unit_id}
										options={unitOption || []}
										infoIcon={true}
										required={true}
										autoFocus={isMeasuringUnitFocus}
										error={error?.unit_id}
										onAddNew={() => {
											setIsOpenMeasuringUnitModel(true);
											setMeasuringUnitFocus(false);
										}}
									/>
								</div>
								<div
									className="col-3 align-content-center"
									style={{ marginTop: '33px' }}
								>
									<Checkbox
										label="Sell Loose"
										checked={Boolean(formData.sell_loose)}
										onChange={handleCheckboxChange}
										error={error?.sell_loose}
									/>
								</div>
							</div>
						</div>
						<div className="col">
							<InputSelect
								label="Shelf ID"
								placeholder="Select Shelf ID"
								onChange={(value) => setShelf(value)}
								value={shelf}
								options={shelfOption || []}
								onAddNew={() => setIsShelfId(true)}
								infoIcon={true}
								error={error?.shelf_id}
								autoFocus={false}
							/>
						</div>
					</div>
					<div className="row">
						<div className="col-8">
							<div className="row">
								<div className="col">
									<InputSelect
										options={taxesList}
										label="Tax1"
										placeholder="Tax1"
										required={false}
										error={error?.tax1}
										value={formData.tax1}
										returnInputValue={false}
										onChange={(value) => {
											if (value === '') {
												setFormData((prev) => ({
													...prev,
													tax1: '',
												}));
											}
										}}
										onSelect={(option) => {
											setFormData((prev) => ({
												...prev,
												tax1: option.key,
											}));
										}}
										autoFocus={false}
									/>
								</div>
								<div className="col">
									<InputSelect
										options={taxesList}
										label="Tax2"
										placeholder="Tax2"
										required={false}
										error={error?.tax2}
										value={formData.tax2}
										returnInputValue={false}
										onChange={(value) => {
											if (value === '') {
												setFormData((prev) => ({
													...prev,
													tax2: '',
												}));
											}
										}}
										onSelect={(option) => {
											setFormData((prev) => ({
												...prev,
												tax2: option.key,
											}));
										}}
										autoFocus={false}
									/>
								</div>
								<div className="col">
									<InputField
										label="Discount"
										placeholder="0.00"
										type="text"
										onChange={(value) => handleInputChange('purchase_discount', value)}
										value={formData.purchase_discount}
										error={error?.purchase_discount}
									/>
								</div>
								<div className="col">
									<InputField
										label="Min Stock"
										placeholder="0"
										type="text"
										onChange={(value) => handleInputChange('min_stock', value)}
										value={formData.min_stock}
										error={error?.min_stock}
									/>
								</div>
								<div className="col">
									<InputField
										label="Max Stock"
										placeholder="0"
										type="text"
										onChange={(value) => handleInputChange('max_stock', value)}
										value={formData.max_stock}
										error={error?.max_stock}
									/>
								</div>
							</div>
						</div>
						<div className="col-4">
							<InputField
								label="Generic Name"
								placeholder=""
								type="text"
								onChange={(value) => handleInputChange('generic_name', value)}
								value={formData.generic_name}
								error={error?.generic_name}
							/>
						</div>
					</div>
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'end',
							marginTop: '10px',
							gap: '10px',
						}}
					>
						<Button
							type="button"
							button={`Cancel`}
							className="mt-0 px-4 btn-gray relative"
							onClick={() => setIsOpenProductModal(false)}
						/>
						<Button
							type="button"
							button={`Save`}
							disabled={loader}
							className="mt-0 px-4 btn-primary relative"
							onClick={() => SubmitForm()}
							loader={loader}
						/>
					</div>
				</div>
			</Modal>
			{open && (
				<div>
					<Modal
						className="add-productgroup-modal"
						isOpen={open}
						cancelButton={() => setOpen(false)}
						onClose={() => setOpen(false)}
						title="Add New Group"
					>
						<AddProductGroup
							isOpen={open}
							onCLose={() => setOpen(false)}
							setPersistGroupName={setPersistGroupName}
							setAutoFocus={setAutoFocus}
							reloadTable={groupList}
							openGroupCode={() => {
								setIsOpenGroupCodeModel(true);
							}}
							callBackFunction={HandleGroupChange}
							shouldCallCalback={true}
						/>
					</Modal>
				</div>
			)}
			{isOpenGroupCodeModel && (
				<div>
					<Modal
						className="add-productgroup-modal"
						isOpen={isOpenGroupCodeModel}
						cancelButton={() => {
							setIsOpenGroupCodeModel(false);
						}}
						onClose={() => {
							setIsOpenGroupCodeModel(false);
						}}
						title="Add Group Code"
					>
						<CreateGroupCodeModel
							isOpen={isOpenGroupCodeModel}
							onCLose={() => {
								setIsOpenGroupCodeModel(false);
							}}
							reloadTable={() => {
								groupList();
							}}
							setGroupCode={setGroupCode}
							groupCode={groupCode}
							groupId={group}
						/>
					</Modal>
				</div>
			)}
			{isOpenCatogery && (
				<div>
					<Modal
						className="add-productgroup-modal"
						isOpen={isOpenCatogery}
						cancelButton={() => setIsOpenCatogery(false)}
						onClose={() => setIsOpenCatogery(false)}
						title="Add New Category"
					>
						<ProductCatogery
							isOpen={isOpenCatogery}
							onCLose={() => setIsOpenCatogery(false)}
							reloadTable={catogeryList}
							setAutoFocus={setAutoFocus}
							setPersistCatogery={setPersistCategory}
							handleCatogery={handleCatogery}
						/>
					</Modal>
				</div>
			)}

			{isSheifId && (
				<div>
					<Modal
						className="add-productgroup-modal"
						isOpen={isSheifId}
						cancelButton={() => setIsShelfId(false)}
						onClose={() => setIsShelfId(false)}
						title="Add New shelf"
					>
						<Addshelf
							isOpen={isSheifId}
							onCLose={() => setIsShelfId(false)}
							reloadTable={shelfList}
							setAutoFocus={setAutoFocus}
							setPersistShelf={setPersistShelf}
							setShelf={setShelf}
						/>
					</Modal>
				</div>
			)}
			{isOpenPackagingModel && (
				<AddPackagingModel
					isOpenModal={isOpenPackagingModel}
					setIsOpenModal={setIsOpenPackagingModel}
					getList={getInventoryPackaging}
					setPackagingOption={setPackagingOption}
					setFormData={setFormData}
					setPackagingFocus={setPackagingFocus}
				/>
			)}
			{isOpenMeasuringUnitModel && (
				<AddMeasuringUnitModel
					isOpenModel={isOpenMeasuringUnitModel}
					setIsOpenModel={setIsOpenMeasuringUnitModel}
					setMeasuringUnitFocus={setMeasuringUnitFocus}
					setFormData={setFormData}
					setMeasuringUnitOption={setUnitOption}
					getList={getInventoryMeasuringUnit}
				/>
			)}
		</>
	);
}
